import { render, staticRenderFns } from "./liaison.vue?vue&type=template&id=3d43da42&scoped=true&"
import script from "./liaison.vue?vue&type=script&lang=js&"
export * from "./liaison.vue?vue&type=script&lang=js&"
import style0 from "./liaison.vue?vue&type=style&index=0&id=3d43da42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d43da42",
  null
  
)

export default component.exports